export const getScoreColorClass = (score: number): string => {
  if (score >= 0 && score < 45) {
    return "text-indigo-800"; // primaryDarkBlue
  }
  if (score >= 45 && score < 75) {
    return "text-sky-600"; // primaryBlue
  }
  return "text-emerald-500"; // primaryGreen
};
